export enum Environment {
    LOCAL = 'local',
    PMDEV = 'pmdev',
    DEV = 'dev',
    PMQA = 'pmqa',
    DEMO = 'demo',
    PRODUCTION = 'production'
}